import controller from './search.controller';
import template from './search.html';

let searchComponent = {
    template,
    controller
};

export default searchComponent;
